import React from 'react'

const ChatSection = () => {
  return <div>Sección en construcción</div>
}

export default ChatSection
